import React from 'react';
import { CheckIcon } from 'lucide-react';
export function PricingSection() {
  return <section id="order" className="py-6 text-gray-800" data-id="element-85">
      <h2 className="text-2xl font-bold mb-6 text-center" data-id="element-86">
        Get the Same Device That Transformed Linda's Life
      </h2>
      <div className="bg-gray-100 p-6 rounded-lg mb-8" data-id="element-87">
        <h3 className="text-xl font-bold mb-4" data-id="element-88">
          The Complete Knee Relief System includes:
        </h3>
        <div className="mb-4 flex items-start" data-id="element-89">
          <CheckIcon className="h-5 w-5 text-green-500 mr-2 mt-1 flex-shrink-0" data-id="element-90" />
          <div data-id="element-91">
            <p className="font-bold" data-id="element-92">
              Professional-Grade Therapeutic Device (Retail Value: $299)
            </p>
            <ul className="list-disc pl-8 mb-4 space-y-1 text-sm" data-id="element-93">
              <li data-id="element-94">4-in-1 therapy: Heat, Red Light, Massage, Compression</li>
              <li data-id="element-95">Rechargeable battery (cordless convenience)</li>
              <li data-id="element-96">Adjustable settings for personalized comfort</li>
              <li data-id="element-97">Automatic 15-minute timer with safety shut-off</li>
            </ul>
          </div>
        </div>
        <div className="mb-4 flex items-start" data-id="element-98">
          <CheckIcon className="h-5 w-5 text-green-500 mr-2 mt-1 flex-shrink-0" data-id="element-99" />
          <div data-id="element-100">
            <p className="font-bold" data-id="element-101">
              FREE BONUS: "5 Gentle Exercises for Knee Health" Guide (Value:
              $29)
            </p>
            <ul className="list-disc pl-8 mb-4 space-y-1 text-sm" data-id="element-102">
              <li data-id="element-103">Linda's favorite complementary exercises</li>
              <li data-id="element-104">Illustrated step-by-step instructions</li>
              <li data-id="element-105">Tips for maintaining knee mobility</li>
            </ul>
          </div>
        </div>
        <div className="mb-4 flex items-start" data-id="element-106">
          <CheckIcon className="h-5 w-5 text-green-500 mr-2 mt-1 flex-shrink-0" data-id="element-107" />
          <div data-id="element-108">
            <p className="font-bold" data-id="element-109">
              90-Day Money-Back Guarantee (Value: Priceless peace of mind)
            </p>
            <ul className="list-disc pl-8 mb-4 space-y-1 text-sm" data-id="element-110">
              <li data-id="element-111">Try it risk-free for 3 full months</li>
              <li data-id="element-112">
                If you're not completely satisfied, return for full refund
              </li>
              <li data-id="element-113">No questions asked policy</li>
            </ul>
          </div>
        </div>
        <div className="mb-4 flex items-start" data-id="element-114">
          <CheckIcon className="h-5 w-5 text-green-500 mr-2 mt-1 flex-shrink-0" data-id="element-115" />
          <p className="font-bold" data-id="element-116">FREE Shipping & Handling (Value: $19.95)</p>
        </div>
        <div className="mb-4 flex items-start" data-id="element-117">
          <CheckIcon className="h-5 w-5 text-green-500 mr-2 mt-1 flex-shrink-0" data-id="element-118" />
          <p className="font-bold" data-id="element-119">2-Year Manufacturer Warranty (Value: $49)</p>
        </div>
        <div className="border-t border-gray-300 mt-6 pt-6" data-id="element-120">
          <p className="font-bold mb-2" data-id="element-121">Total Value: $396.95</p>
          <p className="font-bold mb-2" data-id="element-122">Your Investment Today</p>
          <p className="mb-2" data-id="element-123">
            <span className="line-through" data-id="element-124">Regular Price: $299</span>
          </p>
          <p className="mb-2" data-id="element-125">
            <span className="line-through" data-id="element-126">Sale Price: $199</span>
          </p>
          <p className="text-2xl font-bold text-red-600 mb-4" data-id="element-127">
            Special Limited-Time Price: Just $149
          </p>
          <p className="italic mb-6" data-id="element-128">
            "Less than what I used to spend on pain pills in one month," Linda
            points out.
          </p>
          <p className="font-bold mb-2" data-id="element-129">Payment Options</p>
          <ul className="list-disc pl-8 mb-6 space-y-1" data-id="element-130">
            <li data-id="element-131">One-time payment of $149</li>
            <li data-id="element-132">Or 3 easy payments of $49.67</li>
            <li data-id="element-133">Secure checkout with buyer protection</li>
            <li data-id="element-134">All major credit cards accepted</li>
          </ul>
        </div>
      </div>
      <div className="bg-yellow-100 p-6 rounded-lg mb-8" data-id="element-135">
        <h3 className="text-xl font-bold mb-4 text-center" data-id="element-136">
          The No-Risk Promise
        </h3>
        <p className="mb-6 leading-relaxed text-center" data-id="element-137">
          Try Linda's morning ritual for 90 days. If you don't experience the
          same relief she did, return the device for a complete refund.
        </p>
        <p className="mb-6 leading-relaxed text-center font-bold" data-id="element-138">
          You literally have nothing to lose except your knee pain.
        </p>
      </div>
      <div className="mb-8" data-id="element-139">
        <h3 className="text-xl font-bold mb-4 text-center" data-id="element-140">
          Your Choice Is Clear
        </h3>
        <p className="mb-6 leading-relaxed" data-id="element-141">
          Right now, you have two paths ahead of you:
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-142">
          <div className="bg-gray-100 p-4 rounded-lg" data-id="element-143">
            <h4 className="font-bold mb-2" data-id="element-144">Path 1:</h4>
            <p className="leading-relaxed" data-id="element-145">
              Continue doing what you're doing. Keep taking pills that don't
              solve the problem. Keep avoiding activities you love. Keep feeling
              older than your years. Keep hoping your knee pain will magically
              improve on its own.
            </p>
          </div>
          <div className="bg-green-100 p-4 rounded-lg" data-id="element-146">
            <h4 className="font-bold mb-2" data-id="element-147">Path 2:</h4>
            <p className="leading-relaxed" data-id="element-148">
              Follow Linda's example. Try the same natural solution that gave
              her – and thousands of other women – their lives back. Take 10
              minutes each morning to invest in pain-free movement and renewed
              confidence.
            </p>
          </div>
        </div>
        <p className="mb-6 leading-relaxed italic" data-id="element-149">
          "If you're reading this and relating to my story, please don't wait
          like I did," Linda says. "You deserve to live without pain. You
          deserve to feel strong and confident in your body again.
        </p>
        <p className="mb-6 leading-relaxed italic" data-id="element-150">
          This device gave me my life back. It can do the same for you."
        </p>
      </div>
      <div className="text-center mb-8" data-id="element-151">
        <h3 className="text-xl font-bold mb-4" data-id="element-152">
          Order Your Knee Relief System Now
        </h3>
        <a href="#order" className="bg-red-600 hover:bg-red-700 text-white font-bold py-3 px-8 rounded-lg text-xl inline-block mb-4" data-id="element-153">
          YES! I Want Linda's Pain-Free Life - Order Now
        </a>
        <p className="text-sm mb-6" data-id="element-154">
          90-Day Money-Back Guarantee • FREE Shipping • Secure Checkout
        </p>
        <p className="mb-6" data-id="element-155">Or call: 1-800-XXX-XXXX</p>
        <p className="mb-6 leading-relaxed font-medium" data-id="element-156">
          Don't let another day of unnecessary pain pass by. Your pain-free
          morning ritual is just one click away.
        </p>
      </div>
    </section>;
}